import { atom, useAtom } from 'jotai';
import { useEffect, useMemo } from 'react';
import { CustomerJobStatus } from 'api/domain/entities/CustomerJob';

import { JobFiltersFields } from 'targets/customer-portal/modules/jobs/components/JobFilters';

export type PageType = 'active-jobs' | 'completed-jobs';

const filtersAtom = atom<Partial<JobFiltersFields & { limit: number }>>({});

export const useCustomerJobViewFilters = (pageType: PageType) => {
  const [filters, setFilters] = useAtom(filtersAtom);

  const allowedStatuses = useMemo(
    () =>
      pageType === 'active-jobs'
        ? [
            CustomerJobStatus.Enum.approved,
            CustomerJobStatus.Enum.in_progress,
            CustomerJobStatus.Enum.submitted,
          ]
        : [
            CustomerJobStatus.Enum.completed,
            CustomerJobStatus.Enum.cancelled,
            CustomerJobStatus.Enum.declined,
          ],
    [pageType],
  );

  useEffect(() => {
    setFilters((f) => ({ ...f, status: undefined }));
  }, [setFilters, pageType]);

  const effectiveFilters = useMemo(() => {
    const { status, ...rest } = filters;
    return {
      ...rest,
      status: (status ? [status] : allowedStatuses) as CustomerJobStatus[],
    };
  }, [filters, allowedStatuses]);

  return {
    filters,
    setFilters,
    allowedStatuses,
    effectiveFilters,
  };
};
